import React, { useCallback } from "react";
import * as Survey from "survey-react";
import * as widgets from "@ugnx/surveyjs-widgets";
import "survey-react/survey.css";
import PropTypes from "prop-types";
import $ from "jquery";
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import styled, { withTheme } from "styled-components";
//Widget imports from webpack node_modules
import "jquery-ui/themes/base/all.css";
import "nouislider/distribute/nouislider.css";
import "select2/dist/css/select2.css";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import "jquery-bar-rating/dist/themes/css-stars.css";
import "jquery-bar-rating/dist/themes/fontawesome-stars.css";
import "jquery-ui/ui/widgets/datepicker.js";
import "select2/dist/js/select2.js";
import "jquery-bar-rating";
import "pretty-checkbox/dist/pretty-checkbox.css";
import { SurveyParams, SurveyThemes } from "../../../modules/constants";
import { getPropertyNoCase } from "../../../modules/utils";

//Initialize widgets
widgets.icheck(Survey, $);
widgets.prettycheckbox(Survey);
widgets.select2(Survey, $);
widgets.inputmask(Survey);
widgets.jquerybarrating(Survey, $);
widgets.jqueryuidatepicker(Survey, $);
widgets.nouislider(Survey);
widgets.select2tagbox(Survey, $);
widgets.sortablejs(Survey);
widgets.ugnxvasscale(Survey, $);

const StyledSurvey = styled.div`
  .sv_main {
    font-family: "Arial" !important;
  }

  .sv_row,
  .sv_qstn {
    min-width: 242px;
  }

  .sv_row > div {
    min-width: 242px !important;
  }

  .sv_main.sv_default_css input[type="button"],
  .sv_default_css button {
    color: white;
    background-color: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props)} !important;
  }

  .sv_main.sv_default_css input[type="button"]:hover,
  .sv_default_css button:hover {
    color: white;
    background-color: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props, false)} !important;
  }

  .sv-ranking {
    pointer-events: ${(props) => (props?.surveyResults ? "none" : "auto")};
  }

  .sv-ranking-item__icon {
    fill: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props)} !important;
  }

  .sv-ranking-item__index {
    background: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props, false)} !important;
  }

  :root {
    --primary-color: black;
  }

  /* Checkbox */

  input[type="checkbox"] {
    height: 14px;
    width: 14px;
    position: relative;
    -webkit-appearance: none;
  }

  input[type="checkbox"]:before {
    content: "";
    display: inline-block;
    position: absolute;
    box-sizing: border-box;
    height: 16px !important;
    width: 16px !important;
    border-radius: 2px;
    border: 1px solid #767676;
    background-color: #fff;
    transition: all 0.3s ease-in;
  }

  input[type="checkbox"]:hover::before {
    border: 1px solid #4f4f4f;
  }

  input[type="checkbox"]:checked:hover::before {
    filter: brightness(90%);
  }

  input[type="checkbox"]:checked:disabled:hover::before {
    filter: none;
  }

  input[type="checkbox"]:checked:before {
    content: "";
    display: inline-block;
    position: absolute;
    box-sizing: border-box;
    height: 16px !important;
    width: 16px !important;
    border-radius: 2px;
    border: 1px solid
      ${(props) => themeParser(props?.surveyData?.surveyTheme, props)};
    background-color: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props)};
    transition: all 0.3s cubic-bezier(0.25, 0.25, 0.56, 2);
  }

  input[type="checkbox"]:checked:after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 6px;
    left: 3px;
    box-sizing: border-box;
    height: 5px;
    width: 10px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    -webkit-transform: translateY(-1.5px) rotate(-45deg);
    transform: translateY(-1.5px) rotate(-45deg);
  }

  input[type="checkbox"]:disabled::before {
    border: 1px solid #c9ced1;
    border-radius: 2px;
    background-color: #f0f4f8;
  }

  input[type="checkbox"]:checked:disabled::before {
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    background-color: #d1d1d1;
  }

  /* Radio CSS */
  input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
  }

  input[type="radio"] {
    width: 20px !important;
    height: 20px !important;
    border-radius: 10px;
    border: 2px solid gray;
    /* Adjusts the position of the checkboxes on the text baseline */
    vertical-align: -2px;
    outline: none;
  }

  input[type="radio"]::before {
    display: block;
    content: " ";
    width: 16px !important;
    height: 16px !important;
    border-radius: 10px;
    background-color: ${(props) =>
      themeParser(props?.surveyData?.surveyTheme, props)};
    font-size: 1.2em;
    transform: translate(0px, 0px) scale(0);
    transform-origin: center;
    transition: all 0.3s ease-in;
  }

  input[type="radio"]:checked::before {
    transform: translate(0px, 0px) scale(1);
    transition: all 0.3s cubic-bezier(0.25, 0.25, 0.56, 2);
  }

  input[type="radio"]:disabled {
    border: 2px solid #d1d1d1;
    background-color: #f0f4f8;
  }

  input[type="radio"]:disabled::before {
    background-color: #fff;
  }

  input[type="radio"]:checked:disabled {
    border: 2px solid #d1d1d1;
    background-color: #d1d1d1;
  }

  input[type="radio"]:checked:disabled::before {
    background-color: #d1d1d1;
  }
`;

const themeParser = (theme, props, primary = true) => {
  switch (theme) {
    case SurveyThemes.RARIFY:
      return primary ? props.theme?.darkPurple : props.theme?.lavenderRose;
    case SurveyThemes.EQ5D5L:
      return primary ? props.theme?.black : props.theme?.gray;
    default:
      break;
  }
};

const SurveyReader = (props) => {
  const { surveyData, onComplete, className, surveyResults = null } = props;
  // Default theme settings
  let defaultThemeColors = Survey.StylesManager.ThemeColors["default"];
  defaultThemeColors["$main-color"] = themeParser(
    surveyData?.surveyTheme,
    props
  );
  defaultThemeColors["$main-hover-color"] = themeParser(
    surveyData?.surveyTheme,
    props,
    false
  );
  surveyData && Survey.StylesManager.applyTheme();

  const model = new Survey.Model(
    getPropertyNoCase(surveyData, SurveyParams.model)
  );

  const loadDatePicker = useCallback(() => {
    $("input[type=datetime]").datepicker({ dateFormat: "mm/dd/yy" });
  }, []);

  useEffect(() => {
    loadDatePicker();
    if (model && surveyResults) {
      model.data = JSON.parse(
        getPropertyNoCase(surveyResults, SurveyParams.model)
      );
      model.mode = "display";
      model.questionsOnPageMode = "singlePage";
      model.showNavigationButtons = "none";
    }
  }, [loadDatePicker, model, surveyResults]);

  useEffect(() => {
    if (!surveyResults) {
      model.clear();
    }
  }, [model, surveyResults]);

  return surveyData ? (
    <StyledSurvey
      className={className}
      {...{ surveyData }}
      {...{ surveyResults }}
    >
      <Survey.Survey model={model} onComplete={onComplete} />
    </StyledSurvey>
  ) : (
    <Spinner
      data-testid="spinner"
      className="d-flex mx-auto"
      animation="border"
    />
  );
};

SurveyReader.propTypes = {
  onComplete: PropTypes.func,
  surveyData: PropTypes.shape({
    surveyTheme: PropTypes.string.isRequired,
  }),
};
SurveyReader.defaultProps = {
  surveyData: {
    surveyTheme: SurveyThemes.RARIFY,
  },
};

export default withTheme(SurveyReader);
